import React from 'react';
import Shimmer from '@magento/venia-ui/lib/components/Shimmer'; //'../Shimmer';

import { useStyle } from '@magento/venia-ui/lib/classify'; //'../../classify';

import defaultClasses from './option.module.css';
import TileListShimmer from './tileList.shimmer';

var OptionShimmer = function OptionShimmer(props) {
  var classes = useStyle(defaultClasses, props.classes);
  return React.createElement("div", {
    className: classes.root
  }, React.createElement("h3", {
    className: classes.title
  }, React.createElement("span", null, React.createElement(Shimmer, {
    width: "100%"
  }))), React.createElement(TileListShimmer, null), React.createElement("div", {
    className: classes.selection
  }, React.createElement(Shimmer, {
    width: "100%"
  })));
};

export default OptionShimmer;